import {Box, IconButton, Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import React from 'react';
import {formatText} from 'presentation/utils';
import {formatProviderAddress} from 'presentation/pages/private/authorizations/utils/formatProviderAddress';
import {ProviderItemProps} from './types';

export const ProviderItem = ({provider, handleToggleProvider}: ProviderItemProps) => {
	const theme = useTheme();

	return (
		<Stack
			key={provider.idUnico}
			flexDirection="row"
			justifyContent="space-between"
			sx={{
				p: 2,
				border: `1px solid ${theme.palette.divider}`,
				borderRadius: 1,
				backgroundColor: theme.palette.background.paper,
			}}>
			<Box display="flex" justifyContent="space-between" alignItems="center" gap={1}>
				<Typography variant="body2" color="text.primary">
					<strong>{formatText(provider?.nmPrestador)}</strong> -{' '}
					{formatProviderAddress(provider)}
				</Typography>
			</Box>

			<IconButton
				sx={{p: 0, alignSelf: 'baseline'}}
				size="medium"
				onClick={() => handleToggleProvider(provider)}>
				<Icon name="close-default" color={theme.colors.brand.primary.blue} />
			</IconButton>
		</Stack>
	);
};
